// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_j0-6";
export var emphasizeQuantity = "_j0-3";
export var flatBottomCorners = "_j0-5";
export var productImage = "_j0-0";
export var quantityContainer = "_j0-2";
export var tooltip = "_j0-1";
export var wrapAndEllipsesOverflow = "_j0-4";